import axios from 'axios';


const url = '/api/configuration/profile';

export const get = () => axios.get(url)
    .then(response => response.data);

export const update = ({ userSettings }) => axios.post(url, { userSettings })
    .then(response => response.data);



// WEBPACK FOOTER //
// ../utils/api/configuration/profile.js